'use client';

import { FC } from 'react';

import { useAuthentication } from '@ravago/shared/authentication';
import { NodeTypes } from '@ravago/shared/page-data/enums/node-types';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';

import { usePathname, useSearchParams } from 'next/navigation';

import { AppUtils } from '../../../utils/app/app.utils';

interface Props {
   buttonLabel: string;
   leadingIcon?: string;
   trailingIcon?: string;
   variant?: 'primary' | 'secondary' | 'tertiary' | 'error' | 'ghost';
   fullwidth?: boolean;
   redirectUrl?: string;
   testId?: string;
}

export const LoginButton: FC<Props> = ({ buttonLabel, leadingIcon, trailingIcon, variant = 'secondary', fullwidth = false, redirectUrl, testId }) => {
   const pathname = usePathname();
   const searchParams = useSearchParams();
   const { login } = useAuthentication();

   const handleLogin = () => {
      if (typeof window !== 'undefined') {
         localStorage.setItem('navigationPendingScrollPosition', window.scrollY.toString());
      }

      const currentUrl = `${pathname}?${searchParams.toString()}`;

      login(redirectUrl ?? currentUrl);
   };

   return (
      <Box direction={fullwidth ? 'column' : 'row'} width={fullwidth ? '100%' : undefined}>
         <Button
            onClick={handleLogin}
            fullWidth={fullwidth}
            variant={variant}
            leadingIcon={leadingIcon}
            trailingIcon={trailingIcon}
            attributes={{ 'test-selector': AppUtils.getTestSelector(buttonLabel, NodeTypes.LOGIN_BUTTON, testId) }}
         >
            {buttonLabel}
         </Button>
      </Box>
   );
};
